import React from 'react';
import { CSSObject } from '@emotion/react';
import useBlockTheme from '@cvent/blocks/hooks/useTheme';
import Skeleton from '@cvent/carina/components/Skeleton';
import { injectTestId } from '@cvent/nucleus-test-automation';
import { useTranslate } from 'nucleus-text';

const useStyles = (): Record<string, CSSObject> => {
  const { block } = useBlockTheme();

  return {
    titleSkeleton: { backgroundColor: block.base, opacity: '50%', marginTop: '60px', marginBottom: '16px' },
    subtitleSkeleton: { backgroundColor: block.base, opacity: '50%', marginBottom: '50px' },
    fieldSkeleton: { backgroundColor: block.base, opacity: '50%', marginBottom: '16px' },
    buttonSkeleton: { backgroundColor: block.base, opacity: '50%' }
  };
};

function RegistrationFormSkeletonLoader(): JSX.Element {
  const { titleSkeleton, subtitleSkeleton, fieldSkeleton, buttonSkeleton } = useStyles();
  const { size } = useBlockTheme();
  const { translate } = useTranslate();

  return (
    <div
      {...injectTestId('registration-form-skeleton-loader')}
      role="progressbar"
      aria-label={translate('LandingPage-RegistrationForm-SkeletonLoader-AccessibilityLabel')}
    >
      <Skeleton
        borderRadius={size.border.radius.fiveX}
        hasShimmer
        height="16px"
        width="54%"
        css={titleSkeleton}
        {...injectTestId('registration-form-skeleton-loader-title')}
      />
      <Skeleton
        borderRadius={size.border.radius.fiveX}
        hasShimmer
        height="16px"
        width="69%"
        css={subtitleSkeleton}
        {...injectTestId('registration-form-skeleton-loader-subtitle')}
      />
      <Skeleton
        borderRadius={size.border.radius.fiveX}
        hasShimmer
        height="60px"
        width="100%"
        css={fieldSkeleton}
        lines={4}
        {...injectTestId('registration-form-skeleton-loader-fields')}
      />
      <Skeleton
        borderRadius={size.border.radius.fiveX}
        hasShimmer
        height="44px"
        width="28%"
        css={buttonSkeleton}
        {...injectTestId('registration-form-skeleton-loader-button')}
      />
    </div>
  );
}

export default RegistrationFormSkeletonLoader;
